import dates from "@/services/date";

const VAT = 0.2;
const SHOP_NAME = 'BoilerGuide Installer Dashboard';
const SHIPPING_PRICE = 0;

export default {
  methods: {
    logTransaction: function (leads, company, bulk) {
      let products = [];
      let total = 0;
      leads.forEach((lead) => {
        const product = this.product(lead, company, bulk);
        total += lead.invoiced;
        products.push(product);
      });

      this.transaction(total, products, company, bulk);

      this.$ga.ecommerce.send();
    },

    transaction: function(total, products, company, bulk) {
      const id = (bulk ? 'bulk-' : '') +  dates.getTimestamp() + '-' + company.id;
      const transaction = {
        'id': id,
        'affiliation': SHOP_NAME,
        'revenue': (total * (1 + VAT)),
        'tax': (total * VAT),
        'shipping': SHIPPING_PRICE,
        'dimension2': bulk,
      };
      this.$ga.ecommerce.setAction('purchase', transaction);
    },

    product: function(lead, company, bulk) {
      const type = lead.availability_guarantee === 0 ? 'Marketplace' : 'Offered';
      const price = lead.invoiced;
      const productName = type
        + ' '
        + lead.enquiry.site.sitename
        + ' Lead ('
        + lead.enquiry.work_type_description
        + ')';
      const sku = lead.enquiry.work_type.id + '-' + lead.code;

      const product = {
        'id' : sku,
        'name' : productName,
        'category' : type,
        'brand' : lead.enquiry.site.sitename,
        'price': price * (1 + VAT),
        'quantity': 1,
        'dimension1': company.internal_name,
        'dimension2': bulk,
      };
      this.$ga.ecommerce.addProduct(product);

      return product;
    }
  }
}
